import React, { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  const [display, setDisplay] = useState('0');

  const handleClick = (value) => {
    if (value === '.' && display.includes('.')) return; // Prevent multiple decimal points
    setDisplay((prevDisplay) => prevDisplay === '0' ? value : prevDisplay + value);
  };

  const clearDisplay = () => {
    setDisplay('0');
  };

  const calculate = () => {
    try {
      setDisplay(eval(display).toString());
    } catch (error) {
      setDisplay('Error');
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      const keyValue = event.key;
      const button = document.getElementById(keyValue);
    
      button.classList.add('button-pressed');
    
      setTimeout(() => {
        button.classList.remove('button-pressed');
      }, 100);

      if (!isNaN(keyValue) || keyValue === '.') {
        handleClick(keyValue);
      } else if (keyValue === 'Enter') {
        calculate();
      } else if (keyValue === '+' || keyValue === '-' || keyValue === '*' || keyValue === '/') {
        handleClick(keyValue);
      } else if (keyValue === 'Escape' || keyValue === 'C' || keyValue === 'c' ||  keyValue === 'Backspace' ||  keyValue === 'Delete') {
        clearDisplay();
      }
    };
  
    window.addEventListener('keydown', handleKeyPress);
  
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleClick, clearDisplay, calculate]);

  
  return (
    <div className="calculator">
      <div className="display">{display}</div>
      <div className="buttons">
        <button id="7" className="number-button" onClick={() => handleClick('7')}>7</button>
        <button id="8" className="number-button" onClick={() => handleClick('8')}>8</button>
        <button id="9" className="number-button" onClick={() => handleClick('9')}>9</button>
        <button id="/" className="operator-button" onClick={() => handleClick('/')}>/</button>

        <button id="4" className="number-button" onClick={() => handleClick('4')}>4</button>
        <button id="5" className="number-button" onClick={() => handleClick('5')}>5</button>
        <button id="6" className="number-button" onClick={() => handleClick('6')}>6</button>
        <button id="*" className="operator-button" onClick={() => handleClick('*')}>X</button>

        <button id="1" className="number-button" onClick={() => handleClick('1')}>1</button>
        <button id="2" className="number-button" onClick={() => handleClick('2')}>2</button>
        <button id="3" className="number-button" onClick={() => handleClick('3')}>3</button>
        <button id="-" className="operator-button" onClick={() => handleClick('-')}>–</button>

        <button id="0" className="number-button"onClick={() => handleClick('0')}>0</button>
        <button id="." onClick={() => handleClick('.')} className="number-button">.</button>
        <button id="Delete" className="operator-button" onClick={clearDisplay}>C</button>
        <button id="+" className="operator-button" onClick={() => handleClick('+')}>+</button>
        <button id="Enter" className="operator-button" onClick={calculate}>=</button>
        
      </div>
    </div>
  );
}

export default App;
